
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import CheckboxYesNo from '@/components/common/CheckboxYesNo.vue'
import {required, requiredIf} from 'vuelidate/lib/validators'
import ClientModel from '@/models/ClientModel'
import convertDateDirective from '@/directives/convertDateDirective'
import {isCoprolibDate} from '@/helpers/validators'

@Component({
  components: {
    BaseFormContainer,
    SelectRef,
    CheckboxYesNo
  },
  directives: {
    convertDateDirective
  },
  validations: {
    form: {
      PROPOSITION: {
        required
      },
      DATE_RECEPTION_COMMANDE: {
        required,
        isCoprolibDate
      },
      CODE_REF_COACH: {
        required: requiredIf((form) => {
          if (form.PROPOSITION) {
            const {CODE_REF_OFFRE, PROPOSITION_COACHING} = form.PROPOSITION
            if (CODE_REF_OFFRE === 'S' || CODE_REF_OFFRE === 'P' || PROPOSITION_COACHING) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        })
      }
    }
  }
})
export default class ClientForm extends BaseForm {
  @Prop(Object) prospect!: any
  model = ClientModel

  get displayCoachSelect() {
    if (this.form.PROPOSITION) {
      const {CODE_REF_OFFRE, PROPOSITION_COACHING} = this.form.PROPOSITION
      if (CODE_REF_OFFRE === 'S' || CODE_REF_OFFRE === 'P' || PROPOSITION_COACHING) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
}
